<template>
  <div
    class="timetable-trash timetable-wrapper"
    v-bind:class="{
      'show-menu': showMenu && hasCalendarRail,
      'no-menu': !hasCalendarRail,
    }"
  >
    <div v-if="hasCalendarRail" class="col-left-side menu" @click.stop>
      <div class="time-navigation">
        <span
          v-if="showHideTrashButton"
          class="timetable-view-back navi-icon"
          @click="hideTrash()"
        >
          <i class="icon-arrow-left"></i
        ></span>
        <span class="timetable-trash-title">{{ texts.trash }}</span>
      </div>

      <div class="calendars">
        <a
          class="filter-group-item calendar-item"
          v-for="calendar in calendars"
          @click="selectCalendar(calendar)"
          v-bind:class="{ active: isCalendarActive(calendar) }"
        >
          <span class="calendar-title">
            <span class="calendar-icon">
              <i v-bind:class="calendar.icon || 'icon-user'"></i>
            </span>
            {{ calendar.title }}</span
          >
        </a>
      </div>
    </div>
    <div class="col-right-side">
      <div class="time-navigation">
        <span
          v-if="hasCalendarRail"
          class="navi-icon navi-menu-icon"
          @click.stop="toggleMenu()"
        >
          <i class="icon-menu"></i
        ></span>
        <!-- Without a calendar rail the title and the way back live up here. -->
        <span
          v-if="!hasCalendarRail && showHideTrashButton"
          class="timetable-view-back navi-icon"
          @click="hideTrash()"
        >
          <i class="icon-arrow-left"></i
        ></span>
        <span v-if="!hasCalendarRail" class="timetable-trash-title">{{
          texts.trash
        }}</span>
        <atom-spinner
          class="navi-spinner"
          v-if="isLoading"
          :animation-duration="1000"
          :size="30"
          :color="'#ff1d5e'"
        />

        <div class="settings-navigation">
          <!--<span class="navi-icon navi-icon-settings">-->
          <!--<i class="icon-trash"></i> {{texts.empty_trash}}-->
          <!--</span>-->
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ texts.date }}</th>
              <th>{{ texts.hour }}</th>
              <th>{{ texts.name }}</th>
              <th>{{ texts.calendar }}</th>
              <th v-for="column in extraColumns">{{ column.title }}</th>
              <th>{{ texts.removed }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(event, index) in deletedEvents"
              @click="clickEvent(event)"
            >
              <th>{{ event.start_time | format_date("dddd, D MMMM YYYY") }}</th>
              <td>
                {{ event.start_time | format_time }} -
                {{ event.end_time | format_time }}
              </td>
              <td>{{ event.display_title }}</td>
              <td>
                <!-- instructor_info is an empty array outside practice lessons, so test the name. -->
                <template v-if="hasInstructorInfo(event)">
                  <span>{{ event.instructor_info.full_name }}</span>
                  <practice-lesson-price
                    v-bind:info="event.instructor_info"
                  ></practice-lesson-price>
                </template>
                <!-- Holidays, reservations, emptied lessons: only the calendar name. -->
                <span v-else-if="event.calendar">{{ event.calendar }}</span>
              </td>
              <td v-for="column in extraColumns">{{ event[column.key] }}</td>
              <td>
                {{ event.deleted_at | format_date("HH:mm:ss; DD/MM/YYYY") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <infinite-loading
        @infinite="loadMoreEvents"
        ref="infiniteLoading"
        force-use-infinite-wrapper="timetable-trash"
      >
        <div slot="no-more">Nu mai sunt</div>
        <div slot="no-results">Nu a fost găsit nimic</div>
      </infinite-loading>
    </div>

    <show-event-modal
      action="show"
      :show-restore="!!restoreUrl"
      :show-delete="!!deleteForeverUrl"
      :events-info-url="eventsInfoUrl"
      :local-event-bus="eventBus"
      :texts="texts"
    ></show-event-modal>
  </div>
</template>

<script>
import { loading } from "./mixins/LoadingMixin";
import { EventBus } from "./mixins/EventBus";
import { ConfirmActionMixin } from "./mixins/ConfirmActionMixin";
import ShowEventModal from "./modals/ShowEventModal.vue";
import PracticeLessonPrice from "./components/PracticeLessonPrice.vue";

export default {
  mixins: [loading, EventBus, ConfirmActionMixin],
  components: {
    "show-event-modal": ShowEventModal,
    "practice-lesson-price": PracticeLessonPrice,
  },
  props: {
    trashUrl: {
      default: null,
    },
    restoreUrl: {
      default: null,
    },
    deleteForeverUrl: {
      default: null,
    },
    trashFilters: {
      default: () => {},
    },
    eventsInfoUrl: {
      default: "",
    },
    calendars: {
      default: () => [],
    },
    extraColumns: {
      default: () => [],
    },
    initialSelectedCalendar: {
      default: null,
    },
    refreshPageAfterRestore: {
      default: false,
    },
    showHideTrashButton: {
      default: true,
    },
    translations: {
      default: () => {},
    },
  },

  data() {
    return {
      deletedEvents: [],
      showMenu: $(window).width() > 1000,
      selectedCalendar: this.initialSelectedCalendar,
      requestVerificationCode: 0,
      page: 0,
      take: 30,
      texts: {
        date: "Data",
        hour: "Ora",
        name: "Nume",
        calendar: "Calendar",
        removed: "Șters",
        trash: "Coș de gunoi",
        empty_trash: "Goliți coșul de gunoi.",
        restore_event: "Restabiliți",
        delete_event_forever: "Ștergeți definitiv",
        confirm_restore_event: "Sigur doriți să restaurați acest eveniment?",
        confirm_delete_event_forever:
          "Sigur doriți să ștergeți definitiv acest eveniment?",
        confirm: "Confirmă",
        cancel: "Renunță",
        ...this.translations,
      },
    };
  },

  mounted() {
    console.log("Timetable Trash Component Mounted.");

    this.eventBus.$on("delete-event-forever", this.deleteEventForever);
    this.eventBus.$on("restore-event", this.restoreEvent);
    this.eventBus.$on("restored-event", this.restoredEvent);
  },

  methods: {
    loadMoreEvents($state) {
      if (!this.trashUrl) return;

      this.loading(true);

      const _requestVerificationCode = ++this.requestVerificationCode;

      console.log("GET PAGE> ", this.page);

      axios
        .get(this.trashUrl, {
          params: {
            calendar_id: this.selectedCalendar
              ? this.selectedCalendar.id
              : null,
            skip: this.page * this.take,
            take: this.take,
            ...this.trashFilters,
          },
        })
        .then((response) => {
          if (_requestVerificationCode !== this.requestVerificationCode) return;
          console.log("GET PAGE FINISH> ", this.page);

          if (response.data.deleted_events.length) {
            Array.prototype.push.apply(
              this.deletedEvents,
              response.data.deleted_events
            );
            $state.loaded();
          } else {
            $state.complete();
          }

          this.loading(false);
        });

      this.page++;
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
      this.eventBus.$emit("toggle-menu");
      this.$emit("toggle-menu");
    },

    hideTrash() {
      this.eventBus.$emit("hide-trash-view");
      this.$emit("hide-trash-view");
    },

    selectCalendar(calendar) {
      if (this.selectedCalendar === calendar) {
        this.selectedCalendar = null;
      } else {
        this.selectedCalendar = calendar;
      }

      this.$emit("select-calendar", this.selectedCalendar);
      this.page = 0;
      this.deletedEvents = [];
      this.$refs.infiniteLoading.stateChanger.reset();
    },

    isCalendarActive(calendar) {
      return this.selectedCalendar && this.selectedCalendar?.id === calendar.id;
    },

    hasInstructorInfo(event) {
      return !!(event.instructor_info && event.instructor_info.full_name);
    },

    clickEvent(event, date) {
      this.eventBus.$emit("show-event", event, moment(event.start_time));
    },

    deleteEventForever(event) {
      if (!this.deleteForeverUrl) return;

      this.confirmAction(this.texts.confirm_delete_event_forever)
        .then(() => {
          this.loading(true);

          return axios
            .delete(this.deleteForeverUrl, {
              data: {
                event_id: event.id,
              },
            })
            .then(
              (response) => {
                console.log("DELETE OK", response);
                this.loading(false);
                this.eventBus.$emit(
                  "deleted-event-forever",
                  response.data.event
                );
                this.$delete(
                  this.deletedEvents,
                  this.deletedEvents.indexOf(event)
                );

                this.$notify({
                  group: "app",
                  text: response.data.message,
                  type: "danger",
                });
              },
              (error) => {
                console.log("DELETE ERROR", error.response);
                this.loading(false);

                this.$notify({
                  group: "app",
                  text: error.response.data.message,
                  type: "error",
                });
              }
            );
        })
        .catch(() => {});
    },

    restoreEvent(event) {
      if (!this.restoreUrl) return;

      this.confirmAction(this.texts.confirm_restore_event)
        .then(() => {
          this.loading(true);

          return axios
            .post(this.restoreUrl, {
              event_id: event.id,
            })
            .then(
              (response) => {
                console.log("RESTORE OK", response);
                this.loading(false);
                this.eventBus.$emit("restored-event", response.data.event);
                this.$delete(
                  this.deletedEvents,
                  this.deletedEvents.indexOf(event)
                );

                this.$notify({
                  group: "app",
                  text: response.data.message,
                  type: "success",
                });
              },
              (error) => {
                console.log("RESTORE ERROR", error.response);
                this.loading(false);

                this.$notify({
                  group: "app",
                  text: error.response.data.message,
                  type: "error",
                });
              }
            );
        })
        .catch(() => {});
    },

    restoredEvent(event) {
      if (this.refreshPageAfterRestore) {
        window.location.reload();
      }
    },
  },

  computed: {
    hasCalendarRail() {
      return Array.isArray(this.calendars) && this.calendars.length > 0;
    },
  },

  watch: {
    trashFilters() {
      this.page = 0;
      this.deletedEvents = [];
      this.$refs.infiniteLoading.stateChanger.reset();
    },
  },
};
</script>
<style lang="scss">
// @import './css/timetable-view.scss';
// @import './css/timetable-custom.scss';
</style>
